const refundsContent = [
    {
        id: 1,
        title: 'Eligibility for Refunds',
        content: `Refund requests will be considered under the following circumstances:
        If our services fail to deliver the results as specified in your chosen Growth Plan.
        If you experience technical issues preventing you from accessing our services.
        If you have mistakenly been charged for services you did not receive.`
    },
    {
        id: 2,
        title: 'Refund Request Process',
        content: `To request a refund, you must:
        Contact our customer support team at support@delishHut.com within 30 days of your purchase.
        Provide details about the reason for your refund request and any relevant supporting documentation.
        Allow our team sufficient time to review your request and investigate the matter.
`
    },
    {
        id: 3,
        title: 'Refund Decisions',
        content: `Refund decisions will be made at the discretion of Delish Hut, taking into account the validity of the refund request and whether the refund eligibility criteria have been met. We reserve the right to approve or deny refund requests based on the circumstances of each case.`
    },
    {
        id: 4,
        title: ' Refund Method',
        content: `If your refund request is approved, the refund will be issued using the original payment method used for the purchase. Please note that the processing time for refunds may vary depending on the payment provider.`
    },
    {
        id: 5,
        title: 'Non-Refundable Items',
        content: `The following items are non-refundable:
        Refunds requested beyond 30 days from the date of purchase.
        Refunds requested due to changes in personal circumstances or preferences.
        Refunds requested for reasons not covered under the refund eligibility criteria.`
    },
    {
        id: 6,
        title: 'Changes to the Refund Policy',
        content: `We reserve the right to update or modify this Refund Policy at any time without prior notice. Your continued use of our services after any changes to the Policy constitutes your acceptance of the revised terms.`
    },
    {
        id: 7,
        title: 'Contact Us',
        content: `If you have any questions or concerns regarding this Refund Policy or our services, please contact us at support@delishHut.com.
        By using Delish Hut's services, you acknowledge that you have read, understood, and agree to this Refund Policy.`
    },

]

export default refundsContent;